import { GiftCouponForRedemption } from '@shared/api/giftCoupon/giftCoupon.interface';
import { fileBucketUrl } from '@shared/utils/fileUtils';

export const formatDateTime = (
  date: Date | string | undefined,
  includeSeconds = false,
) => {
  if (!date) return '-';
  const d = new Date(date);
  const y = String(d.getFullYear()).slice(2);
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const h = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  if (includeSeconds) {
    const sec = String(d.getSeconds()).padStart(2, '0');
    return `${y}.${m}.${day} ${h}:${min}:${sec}`;
  }
  return `${y}.${m}.${day} ${h}:${min}`;
};

export const formatDate = (date: Date | string | undefined) => {
  if (!date) return '-';
  const d = new Date(date);
  const y = String(d.getFullYear()).slice(2);
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}.${m}.${day}`;
};

export const formatPhone = (phone: string | undefined) => {
  if (!phone) return '-';
  const numbers = phone.replace(/[^0-9]/g, '');
  if (numbers.length === 11) {
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7)}`;
  }
  return phone;
};

export const getItemName = (coupon: GiftCouponForRedemption) => {
  if (typeof coupon.giftItem === 'object') {
    return coupon.giftItem?.name || coupon.giftItem?.giftItemInfo?.name || '-';
  }
  return '-';
};

export const getChoiceUnitName = (coupon: GiftCouponForRedemption) => {
  if (coupon.selectedChoiceUnit && typeof coupon.selectedChoiceUnit === 'object') {
    return coupon.selectedChoiceUnit.name;
  }
  return null;
};

export const getPriceInfo = (coupon: GiftCouponForRedemption) => {
  if (typeof coupon.giftItem === 'object') {
    return {
      priceRegular: coupon.giftItem?.priceRegular || 0,
      priceRetail: coupon.giftItem?.priceRetail || 0,
      priceWhole: coupon.giftItem?.priceWhole || 0,
      priceRebate: coupon.giftItem?.priceRebate || 0,
    };
  }
  return { priceRegular: 0, priceRetail: 0, priceWhole: 0, priceRebate: 0 };
};

export const getOrdererInfo = (coupon: GiftCouponForRedemption) => {
  const order = typeof coupon.giftOrder === 'object' ? coupon.giftOrder : null;
  if (!order) return { name: '-', phone: '-', purchasedAt: undefined };
  return {
    name: order.bugo?.member?.fullName || '-',
    phone: order.bugo?.member?.phoneNumber || '-',
    purchasedAt: order.paymentDetail?.purchasedAt,
  };
};

export const getImageUrl = (coupon: GiftCouponForRedemption) => {
  if (
    coupon.selectedChoiceUnit &&
    typeof coupon.selectedChoiceUnit === 'object' &&
    coupon.selectedChoiceUnit.image
  ) {
    const img = coupon.selectedChoiceUnit.image;
    const imgUrl = typeof img === 'object' && 'url' in img ? img.url : img;
    if (imgUrl) return fileBucketUrl(imgUrl, 'w200');
  }
  if (typeof coupon.giftItem === 'object') {
    const giftItemImg = coupon.giftItem?.image;
    if (giftItemImg) {
      const imgUrl =
        typeof giftItemImg === 'object' && 'url' in giftItemImg
          ? giftItemImg.url
          : giftItemImg;
      if (imgUrl) return fileBucketUrl(imgUrl, 'w200');
    }
    const giftItemInfoImg = coupon.giftItem?.giftItemInfo?.image;
    if (giftItemInfoImg) {
      const imgUrl =
        typeof giftItemInfoImg === 'object' && 'url' in giftItemInfoImg
          ? giftItemInfoImg.url
          : giftItemInfoImg;
      if (imgUrl) return fileBucketUrl(imgUrl, 'w200');
    }
  }
  return '';
};

export const getChoiceUnitPriceRegular = (
  couponId: string,
  coupons: GiftCouponForRedemption[],
) => {
  const coupon = coupons.find((c) => c._id === couponId);
  if (
    coupon?.selectedChoiceUnit &&
    typeof coupon.selectedChoiceUnit === 'object' &&
    coupon.selectedChoiceUnit.priceRegular
  ) {
    return coupon.selectedChoiceUnit.priceRegular;
  }
  if (typeof coupon?.giftItem === 'object') {
    return coupon.giftItem?.priceRegular || 0;
  }
  return 0;
};
